<template>
  <div>
    <el-card :key="release.id" v-for="release of releases">
      <h3>
        <router-link
          :to="{ name: 'release_preview', params: { release_id: release.id } }"
        >
          {{ release.title }} ({{ release.created_at | parseTime }})
        </router-link>
      </h3>
      <div class="tags">
        <QueryTag
          :key="idx"
          v-for="(tag, idx) of release.tags"
          type="info"
          :tagName="tag"
        ></QueryTag>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ParseTimeFilterMixin, RouteQueryTagMixin } from "@/mixins";
import QueryTag from "@/components/QueryTag";
export default {
  name: "ReleasesListPublic",
  props: ["releases"],
  mixins: [ParseTimeFilterMixin, RouteQueryTagMixin],
  components: {
    QueryTag
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
/deep/.el-card__body {
  padding: 10px 20px;
}
a {
  font-size: 1.3em;
  text-decoration: none;
  color: $main-blue;
  &:hover {
    color: $sec-blue;
  }
}
.tags {
  margin-top: -10px;
}
</style>
